
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface PricingCardsProps {
  processingPayment: boolean;
  handleSubscribe: (planType: string) => void;
}

export const PricingCards = ({ processingPayment, handleSubscribe }: PricingCardsProps) => {
  // Price IDs from Stripe
  const priceIds = {
    monthly: "price_1QvOaiG3RRUf49cQgmkP8MtT",
    yearly: "price_1QvObYG3RRUf49cQp6XPRkNN", 
    lifetime: "price_1QvOcGG3RRUf49cQlU0O22em"
  };

  return (
    <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
      <Card className="relative transform transition-all duration-200 hover:scale-105">
        <CardHeader className="pb-8 text-center">
          <CardTitle className="text-xl">Monthly</CardTitle>
          <p className="text-3xl font-bold mt-4">$4.99<span className="text-lg text-gray-500">/mo</span></p>
          <p className="text-sm text-gray-500 mt-2">Billed monthly at $4.99</p>
        </CardHeader>
        <CardContent>
          <Button 
            className="w-full"
            onClick={() => handleSubscribe(priceIds.monthly)}
            disabled={processingPayment}
          >
            Get Started
          </Button>
        </CardContent>
      </Card>

      <Card className="relative border-primary transform transition-all duration-200 hover:scale-105">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-max">
          <span className="bg-primary text-white px-4 py-1 rounded-full text-sm whitespace-nowrap">
            Most Popular
          </span>
        </div>
        <CardHeader className="pb-8 text-center">
          <CardTitle className="text-xl">Yearly</CardTitle>
          <p className="text-3xl font-bold mt-4">$2.50<span className="text-lg text-gray-500">/mo</span></p>
          <p className="text-sm text-gray-500 mt-2">Billed annually at $29.99</p>
        </CardHeader>
        <CardContent>
          <Button 
            className="w-full"
            onClick={() => handleSubscribe(priceIds.yearly)}
            disabled={processingPayment}
          >
            Get Started
          </Button>
        </CardContent>
      </Card>

      <Card className="relative transform transition-all duration-200 hover:scale-105">
        <CardHeader className="pb-8 text-center">
          <CardTitle className="text-xl">Lifetime</CardTitle>
          <p className="text-3xl font-bold mt-4">$199.99</p>
          <p className="text-sm text-gray-500 mt-2">One-time payment</p>
        </CardHeader>
        <CardContent>
          <Button 
            className="w-full"
            onClick={() => handleSubscribe(priceIds.lifetime)}
            disabled={processingPayment}
          >
            Get Started
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
